import React, { useCallback, useEffect, useMemo } from 'react'
import { Checkbox, Radio } from 'antd'
import { useAppSelector, useAppDispatch } from '../../../../app/hooks'
import { setEditorWatermark } from '../../../../actions/watermark'
import { setPaymentVisible } from '../../../../actions/main'
import vip_feat_tag from '../../../../images/vip_feat_tag.png'
import crown_golden from '../../../../images/crown_golden.png'
import time_free_icon from '../../../../images/time-free-icon.png'
import { MUST_FILLED_CLEAR_TYPES } from '../../../../constants/watermark'
import sensors, { parsePlaceValue } from '../../../../utils/sensors'
import classNames from 'classnames'
interface MastFillProps {
  index: number
  clickEvent: (clickItem: string) => void
}

const MustFill: React.FC<MastFillProps> = (props) => {
  const { index, clickEvent } = props
  const isVip = useAppSelector((state) => state.group.isVip)
  const groupID = useAppSelector((state) => state.group.groupId)
  const dispatch = useAppDispatch()
  const watermark = useAppSelector((state) => state.editor.watermark)
  const config = useAppSelector((state) => state.main.config)

  const isMustFilled = useMemo(() => {
    return !!watermark?.items?.[index]?.contentEdit?.isMustFilled
  }, [watermark, index])

  const clearType = useMemo(() => {
    return watermark?.items?.[index]?.contentEdit?.clearTextType
  }, [watermark, index])

  const isPreset = useMemo(() => {
    return watermark?.items?.[index]?.contentEdit?.editType === 2
  }, [watermark, index])

  const isCascade = useMemo(() => {
    return watermark?.items?.[index]?.contentEdit?.editType === 3
  }, [watermark, index])

  const isMultiChoice = useMemo(() => {
    return watermark?.items?.[index]?.contentEdit?.isMultiChoice
  }, [watermark, index])

  const isMultiLevelInput = useMemo(() => {
    return watermark?.items?.[index]?.contentEdit?.isMultiLevelInput
  }, [watermark, index])

  const contentType = useMemo(() => {
    //items[index].contentEdit.editType: 0：输入框，员工手动输入;1：固定内容，员工不可修改；2：预设选项，让员工选择
    if (watermark?.items?.[index]?.contentEdit?.editType < 2) {
      return 'text'
    } else {
      return 'option'
    }
  }, [watermark, index])

  useEffect(() => {
    if (!isVip) {
      sensors.track('web_show_page_openapp_workgroupvip', {
        groupID: groupID,
        place: parsePlaceValue(),
        functionType: 'mustFill'
      })
    }
  }, [])

  const onChange = useCallback(
    (newWatermark) => dispatch(setEditorWatermark(newWatermark)),
    [dispatch]
  )

  const onPay = () => {
    sensors.track('web_click_button_workgroup_go_vip_trigger', {
      place: parsePlaceValue(),
      functionType: 'mustFill',
      groupID
    })
    return dispatch(setPaymentVisible(true, 'watermarkEditorMustFill'))
  }

  const onMustFilledChange = useCallback(
    (e) => {
      sensors.track(
        'web_click_button_workgroup_watermark_item_click_required_field',
        {
          contentType,
          baseID: watermark?.base_id,
          groupID,
          itemID: watermark?.items?.[index]?.id,
          isVip
        }
      )
      clickEvent(e.target.checked ? 'onRequiredfield' : 'offRequiredfield')
      let newItems = watermark.items.map((it, idx) =>
        idx === index
          ? {
              ...it,
              contentEdit: {
                ...it.contentEdit,
                isMustFilled: e.target.checked
              }
            }
          : it
      )
      if (e.target.checked && clearType === undefined) {
        //未设置过clearType，当开启必填时，clearType默认为5分钟清空
        newItems = newItems.map((it, idx) =>
          idx === index
            ? {
                ...it,
                contentEdit: {
                  ...it.contentEdit,
                  clearTextType: MUST_FILLED_CLEAR_TYPES.FIVE_MINUTES
                }
              }
            : it
        )
      }
      onChange({ ...watermark, items: newItems })
    },
    [watermark, index, isVip, clearType, contentType, groupID, onChange, onPay]
  )

  const onClearTypeChange = useCallback(
    (e) => {
      const newItems = watermark.items.map((it, idx) =>
        idx === index
          ? {
              ...it,
              contentEdit: {
                ...it.contentEdit,
                clearTextType: e.target.value
              }
            }
          : it
      )
      onChange({ ...watermark, items: newItems })
      clickEvent(
        e.target.value === MUST_FILLED_CLEAR_TYPES.FIVE_MINUTES
          ? 'clearContentEvery5Min'
          : 'neverClearContent'
      )
    },
    [watermark, isVip, index, onChange, onPay]
  )

  const onMultiChoice = useCallback(
    (e) => {
      const newItems = watermark.items.map((it, idx) =>
        idx === index
          ? {
              ...it,
              contentEdit: {
                ...it.contentEdit,
                isMultiChoice: e.target.checked
              }
            }
          : it
      )
      onChange({ ...watermark, items: newItems })
      clickEvent(e.target.checked ? 'onMultipleChoice' : 'offMultipleChoice')
    },
    [watermark, index, onChange]
  )

  const onMultiLevelInput = useCallback(
    (e) => {
      const newItems = watermark.items.map((it, idx) =>
        idx === index
          ? {
              ...it,
              contentEdit: {
                ...it.contentEdit,
                isMultiLevelInput: e.target.checked
              }
            }
          : it
      )
      onChange({ ...watermark, items: newItems })
      clickEvent(e.target.checked ? 'memberCanEdit' : 'memberCannotEdit')
    },
    [watermark, index, onChange]
  )

  return (
    <div className="is-must-fill-wrapper">
      <p className="tip">水印里的信息需拍照人手动填写</p>
      <div className={classNames('is-must-fill')}>
        <div className="title-wrap">
          <Checkbox checked={isMustFilled} onChange={onMustFilledChange}>
            <strong>内容要求员工必填</strong>
          </Checkbox>

          <div className="time-free">限免</div>
        </div>
        <p className="must-fill-tip">
          确保员工填写正确，拍照必须填写内容，定期自动清空已输入内容
        </p>
        <div className="clear-type">
          <Radio.Group
            disabled={!isMustFilled}
            value={clearType}
            onChange={onClearTypeChange}
          >
            <Radio value={MUST_FILLED_CLEAR_TYPES.FIVE_MINUTES}>
              每{config?.required_field_clear_time || 5}分钟清空
            </Radio>
            <Radio value={MUST_FILLED_CLEAR_TYPES.NEVER}>始终不清空</Radio>
          </Radio.Group>
        </div>
      </div>
      {isPreset && (
        <>
          <Checkbox checked={isMultiChoice} onChange={onMultiChoice}>
            员工可多选
          </Checkbox>
          <Checkbox checked={isMultiLevelInput} onChange={onMultiLevelInput}>
            水印的预设选项若不合适，员工可手动输入
          </Checkbox>
        </>
      )}
      {isCascade && (
        <Checkbox checked={isMultiLevelInput} onChange={onMultiLevelInput}>
          水印的预设选项若不合适，员工可手动输入
        </Checkbox>
      )}
    </div>
  )
}

export default MustFill
